import React, { useState } from 'react';
import useCobroExternos from '../hooks/useCobroExternos';
import useHistorialExternos from '../hooks/useHistorialExternos';
import VistaHistorialExternos from './VistaHistorialExternos';
import VistaCobroExternos from './VistaCobroExternos';
import './CobroExternos.css';

const CobroExternos = ({ user }) => {
  const [vistaActual, setVistaActual] = useState('cobro');

  // 1. Instanciamos el Hook Principal de Cobros
  const cobroProps = useCobroExternos(user);

  // 2. Instanciamos el Hook de Historial
  const historialProps = useHistorialExternos(user, cobroProps.externoSeleccionado);

  // Entidad para cabeceras del historial
  const infoEntidadSeleccionada = cobroProps.externos.find(e => e.matricula === cobroProps.externoSeleccionado) || {};

  // Renderizado Condicional del Router Interno
  if (vistaActual === 'historial') {
    return (
      <VistaHistorialExternos 
        infoEntidad={infoEntidadSeleccionada}
        user={user}
        setVistaActual={setVistaActual}
        cargandoHistorial={historialProps.cargandoHistorial}
        datosHistorial={historialProps.datosHistorial}
      />
    );
  }

  return (
    <VistaCobroExternos 
      {...cobroProps} 
      {...historialProps} 
      setVistaActual={setVistaActual} 
    />
  );
};

export default CobroExternos;